export const COOKIE_KEY_DONATE_NEXT_SHOW = "donateNotifyNS";
export const COOKIE_KEY_DONATE_CLOSED_COUNT = "donateNotifyCC";
export const COOKIE_KEY_DONATE_DAY_USING = "donateNotifyDU";
export const DONATE_TIMEOUT_ALREADY_DONATED = 28987200000; // 335.5 days (11 months).

export const DONATE_DEF_CONFIG = {
  firstTimeDelay: 900000, // 15 min,
  secondTimeDelay: 2419200000, // 28 days.
  showAfterDayUsing: false,
};

const getDonateDelayWithClosedCount = (closedCount, config) => {
  if (closedCount === 0) {
    return config.firstTimeDelay ?? 900000;
  }
  return config.secondTimeDelay ?? 2419200000;// 28 days.
};

export const getDonateTimestampNextShowWithClosedCount = (closedCount, config = DONATE_DEF_CONFIG) => {
  return Date.now() + getDonateDelayWithClosedCount(closedCount, config);
};
